// Angular imports
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

// RxJs imports
import { Observable } from 'rxjs';

// CC-Common imports
import { CCSessionManagerService } from 'cc-common';

/** Inject With Credentials into the request */
@Injectable()
export class CredentialsInterceptor implements HttpInterceptor {
    constructor(private readonly sessionManager: CCSessionManagerService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // TODO: this.sessionManager.reset();
        req = req.clone({
            withCredentials: true
        });
        return next.handle(req);
    }
}
